var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"financing-edit"},[_c('Steps',{attrs:{"stepArray":_vm.stepArray,"width":800,"height":100,"active":_vm.stepsActive}}),_c('router-view',{attrs:{"active":_vm.stepsActive}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }